module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABABAMAAABRrMyXAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABXRSTlMA7yC/r1EOHTEAAABGSURBVEjHY2AyDMULQhQYFEMJACEGV0JKghlCCYFABlGCahhMCakIIca5TATcK6zAMApGwVAFo3l6NE+PguEFRvM01jwNAIs2BjyWv8NnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/003.png
// module id = gLxw
// module chunks = 1